import { render, staticRenderFns } from "./resume10.vue?vue&type=template&id=88dfa4da&scoped=true&"
import script from "./resume10.vue?vue&type=script&lang=js&"
export * from "./resume10.vue?vue&type=script&lang=js&"
import style0 from "./resume10.vue?vue&type=style&index=0&id=88dfa4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dfa4da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCardTitle,VTextarea})
